import * as React from "react";
import type { SVGProps } from "react";
const SvgCheckMarkSmall = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M18.537 5.156a1 1 0 0 1 .307 1.38l-7.637 12a1 1 0 0 1-1.624.089L5.219 13.17a1 1 0 0 1 1.562-1.25l3.49 4.363 6.885-10.82a1 1 0 0 1 1.38-.307"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgCheckMarkSmall;
